export default __webpack_public_path__ + "static/media/audio-icon.5d1fada9.png";